const invitationLinkFailure = "We couldn't create the invitation link. Please try again.";
const deleteTeamNotifiedBody =
  "We tried again, but still couldn't confirm this client was deleted. We've sent the details we need to investigate this, and are working on a fix.";

export const investorCopy = {
  signupLink: {
    alreadyHasAccount: 'This client already has a Wavvest account.',
    copiedButton: 'Link copied',
    copyAgainButton: 'Copy again',
    copyButton: 'Copy invitation link',
    copyFailedButton: 'Link generated',
    copyFailedDescription:
      'The link was created, but your browser blocked automatic copying. Copy it manually below.',
    copyFailedTitle: 'Invitation link created',
    accessDenied: "You don't have access to create an invitation link for this client.",
    generatedButton: 'Generating link',
    generationFailure: invitationLinkFailure,
    missingEmail: 'Add an email to this client before creating an invitation link.',
    manualCopyFailure:
      "We still couldn't copy the invitation link. Copy it manually from the field.",
    networkFailure:
      "We couldn't reach the invitation service. Check your connection and try again.",
    notFound: 'We could not find this client. Refresh the page and try again.',
    accountCreatedStatus: 'Client signup complete',
    tooltip: 'Share this link with the client so they can link their financial accounts.',
  },
  save: {
    createFailure: {
      contactTeamButton: 'Contact our team',
      failedBody:
        "We couldn't confirm this client was saved. Your details are still here. Try again or contact our team.",
      failedBodyAfterRetry:
        "We tried again, but this client still wasn't saved. Your details are still here.",
      failedTitle: "We couldn't save this client",
      notifiedBody:
        "We couldn't confirm this client was saved. We've sent the details we need to investigate this, and are working on a fix.",
      notifiedBodyAfterRetry:
        "We tried again, but this client still wasn't saved. We've sent the details we need to investigate this, and are working on a fix.",
      notifiedTitle: 'Our team has been notified',
      retryingBody:
        "We couldn't confirm this client was saved, so we're trying once more automatically. Your details will stay here.",
      retryingTitle: "We're trying again",
      supportNotificationFailure:
        "We also tried to notify our team about this save error, but that didn't work. Check your connection and try again.",
      tryAgainButton: 'Try again',
      tryingAgainButton: 'Trying again',
    },
    editFailure: {
      accessDeniedBody: "You don't have access to edit this client.",
      conflictBody:
        'These changes conflict with another client record. Review the details and try again.',
      contactTeamButton: 'Contact our team',
      duplicateEmailBody: 'That email is already used by another client.',
      failedBody:
        "We couldn't save these changes. Your edits are still here. Try again or contact our team.",
      failedBodyAfterRetry:
        "We tried again, but these changes still weren't saved. Your edits are still here.",
      failedTitle: "We couldn't save these changes",
      invalidDetailsBody: "Some details don't look valid. Review the form and try again.",
      notFoundBody: 'This client could not be found. Refresh the page and try again.',
      notifiedBody:
        "We couldn't save these changes. We've sent the details we need to investigate this, and are working on a fix.",
      notifiedBodyAfterRetry:
        "We tried again, but these changes still weren't saved. We've sent the details we need to investigate this, and are working on a fix.",
      notifiedTitle: 'Our team has been notified',
      accessDeniedNotifiedBody:
        "You don't have access to edit this client. We've sent the details we need to investigate this, and are working on a fix.",
      retryingBody:
        "We couldn't confirm these changes were saved, so we're trying once more automatically. Your edits will stay here.",
      retryingTitle: "We're trying again",
      supportNotificationFailure:
        "We tried to notify our team about this save error, but that didn't work. Check your connection and try again.",
      tryAgainButton: 'Try again',
      tryingAgainButton: 'Trying again',
    },
    fallbackFailure: {
      action: 'Back to clients',
      createHandoffBody:
        "Client was saved, but we couldn't open the client profile. Go back to the client list and open the client from there.",
      createHandoffTitle: 'Client was saved',
      createUnknownBody:
        "We couldn't confirm this client was saved. Check your connection and refresh the client list before trying again.",
      createUnknownTitle: "We couldn't confirm this client was saved",
      editHandoffBody:
        "Changes were saved, but we couldn't refresh this client page. Go back to the client list and open the client from there.",
      editHandoffTitle: 'Changes were saved',
      editUnknownBody:
        "We couldn't confirm these changes were saved. Check your connection and refresh the client list before trying again.",
      editUnknownTitle: "We couldn't confirm these changes were saved",
    },
  },
  deleteFailure: {
    accessDeniedBody: "You don't have permission to delete this client.",
    contactTeamButton: 'Contact our team',
    failedBody: "We couldn't confirm this client was deleted. Check your connection and try again.",
    failedBodyAfterRetry: "We tried again, but we still couldn't confirm this client was deleted.",
    invalidRequestBody: 'The client list changed while we were deleting this client.',
    notifiedBody: deleteTeamNotifiedBody,
    notifiedTitle: 'Our team has been notified',
    signedUpConflictBody: "This client has already signed up and can't be deleted.",
    supportNotificationFailure:
      "We also tried to notify our team about this delete error, but that didn't work. Check your connection and try again.",
    refreshListButton: 'Reload page',
    refreshListFailure:
      "We tried to refresh the list automatically, but it didn't load. Reload the page to see the latest client status.",
    tryAgainButton: 'Try again',
  },
  locks: {
    email: 'This email is locked because the client has already created an account.',
    nameBySuccessfulKyc:
      'This name is locked because identity verification (KYC) has already completed successfully.',
  },
} as const;
